module.exports = __webpack_public_path__ + "img/3.87e71254.png";